export default "__VITE_ASSET__BWGCBSP1__"